import React, { FunctionComponent } from 'react';
import { Button } from '../../atoms/button';
import { Input } from '../../atoms/input';
import { FlashBox } from '../../atoms/flashBox';
import { Loading } from '../../atoms/loading';
import classnames from 'classnames';

type Props = {
  email: string;
  isLoading: boolean;
  flash: boolean;
  flashType: string;
  flashMessage: string;
  handleFlash: (flash: boolean, type: string, message: string) => void;
  onChangeEmail: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onSubmitPasswordReset: () => void;
};

export const Presentation: FunctionComponent<Props> = ({
  email,
  isLoading,
  flash,
  flashType,
  flashMessage,
  handleFlash,
  onChangeEmail,
  onSubmitPasswordReset,
}) => {
  return (
    <div className="l-wrap l-wrap-old u-clear">
      <div className="password">

        <div className={classnames('common-loading', 'blur', { 'is-active': isLoading })}>
          <Loading />
        </div>
        <FlashBox
          flash={flash}
          flashType={flashType}
          flashMessage={flashMessage}
          handleFlash={handleFlash}
        />
        <div className="password-content">
          <h2 className="password-title">パスワードの再設定</h2>

          <form
            onSubmit={(e) => {
              e.preventDefault();
              onSubmitPasswordReset();
            }}
          >
            <div className="form-group">
              <div className="u-clear">
                <label className="address" htmlFor="email">
                  登録メールアドレス
                </label>
                <Input
                  id="email"
                  type="email"
                  value={email}
                  onChange={onChangeEmail}
                  className="form-control address"
                />
              </div>
            </div>

            <Button
              className="btn btn-default btn-default-password"
              onClicked={onSubmitPasswordReset}
              defaultValue="再設定用メールを送信する"
            />
          </form>
        </div>
      </div>
    </div>
  );
};
